export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,

  /**
   * @description api请求基础路径
   */
  baseUrl: {
    //dev: 'http://inapi.udianbox.com',
    // dev: 'http://47.119.197.16:8888/',
     dev: 'https://api.yyagro.com',
     pro: 'https://api.yyagro.com',
   // dev: 'https://inapi.udianbox.com',
  // pro: 'https://inapi.udianbox.com',
    //pro:'http://47.119.197.16:8888/' https://adminapi.bc-ym.com
    // 'http://mapi.bc-ym.com'
    //  http://testapi.bc-ym.com    http://inapi.udianbox.com
    //    http://112.35.188.133:8888
  },
  projectName: 'yyagro',
  //projectName: 'yumofang',
  // projectName:'ylLive',
  // projectName:'hewego',
  // projectName: 'udian',
  // projectName:'changtong',
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home'
}



// WEBPACK FOOTER //
// ./src/config/index.js